import { useEffect, useState } from "react";
import axios from "axios";
import LightAdmin from "components/headers/lightAdmin";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Footer from "components/footers/FiveColumnWithInputForm.js";

const Purchase = () => {
    const [purchases, setPurchases] = useState([]);
    const token = localStorage.getItem('authToken');
    // Fetch purchases data
    const fetchPurchases = async () => {
        try {
            const response = await axios.get("https://hbmdijital.online/api/admin/get-all-purchases", {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.status === 200) {
                setPurchases(response.data);
            } else {
                console.error("Failed to fetch purchases:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching purchases:", error);
        }
    };


    useEffect(() => {
        if (token) {
            fetchPurchases();
        }
    }, [token]); // Using token as dependency to fetch purchases

    const approvePurchase = async (id) => {
        try {
            const response = await axios.put(
                `https://hbmdijital.online/api/approve-request/${id}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.status === 200) {
                setPurchases((prev) =>
                    prev.map((purchase) =>
                        purchase.id === id ? { ...purchase, status: "Approuvé" } : purchase
                    )
                );
            } else {
                console.error("Failed to approve request:", response.statusText);
            }
        } catch (error) {
            console.error("Error approving purchase:", error);
        }
    };

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex flex-column p-3">
                <div className="d-flex justify-content-start align-items-center gap-2">
                    <h1 className="text-dark display-4">Achat de stock</h1>
                </div>
                <hr className="my-4" />

                {/* Table des demandes d'achat */}
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th>ID Achat</th>
                                <th>Nom Acheteur</th>
                                <th>Montant</th>
                                <th>Statut</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {purchases.map((purchase) => (
                                <tr key={purchase.id}>
                                    <td>{purchase.id}</td>
                                    <td>{purchase.user.name}</td>
                                    <td>{purchase.amount} DH</td>
                                    <td>{purchase.status}</td>
                                    <td>
                                        {purchase.status === "en attente" && (
                                            <button 
                                                onClick={() => approvePurchase(purchase.id)} 
                                                className="btn btn-success">
                                                Approuver
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default Purchase;
